import { Circle, CircleCheck, CircleDot } from 'lucide-react';
import React from 'react';

import { cn } from '@column/ui';

import { CopyButton } from './CopyButton';

export const DomainRecord: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <div className="flex items-center gap-3 border-t border-gray-100 px-4 py-3 first:border-t-0 dark:border-white/[0.08]">
    <div className="grid min-w-0 flex-1 gap-1">
      <span className="text-xs text-muted-foreground">{label}</span>
      <span className="font-mono text-sm font-medium break-all text-foreground">{value}</span>
    </div>
    <CopyButton label={`TXT record ${label.toLowerCase()}`} value={value} />
  </div>
);

type DomainStepState = 'done' | 'current' | 'upcoming';

export const DomainStep: React.FC<{
  title: string;
  description: string;
  state: DomainStepState;
  isLast?: boolean;
  children?: React.ReactNode;
}> = ({ title, description, state, isLast, children }) => (
  <div className={cn('relative grid grid-cols-[20px_minmax(0,1fr)] gap-x-3', isLast ? 'pb-4' : 'pb-9')}>
    {!isLast && <span className="absolute top-7 bottom-1 left-[9px] w-0.5 rounded-full bg-gray-200 dark:bg-white/10" />}
    <span className="flex size-5 items-center justify-center">
      {state === 'done' ? (
        <CircleCheck className="size-5 text-seafoam-600" />
      ) : state === 'current' ? (
        <CircleDot className="size-5 text-foreground" />
      ) : (
        <Circle className="size-5 text-gray-300 dark:text-gray-600" />
      )}
    </span>
    <div className="grid min-w-0 gap-2">
      <div className="grid gap-0.5">
        <h4
          className={cn('m-0 text-sm font-medium', state === 'upcoming' ? 'text-muted-foreground' : 'text-foreground')}
        >
          {title}
        </h4>
        <p className="m-0 text-xs text-muted-foreground">{description}</p>
      </div>
      {children && (
        <div className="overflow-hidden rounded-lg bg-card text-card-foreground shadow-surface-raised dark:bg-gray-800 dark:shadow-[0_0_0_1px_rgb(255_255_255/0.08)]">
          {children}
        </div>
      )}
    </div>
  </div>
);
